import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import PricingSubpageSection1 from "../../components/Pricing/PricingSubpageSection1/PricingSubpageSection1";
import CoreVirtuesValues from "../../components/CoreVirtuesValues/CoreVirtuesValues";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";

const Marketing = () => {
  const { t } = useTranslation("global");
  const basicPlanFeatures = [
    t("marketing.basicFeature1"),
    t("marketing.basicFeature2"),
    t("marketing.basicFeature3"),
  ];

  const standardPlanFeatures = [
    t("marketing.standardFeature1"),
    t("marketing.standardFeature2"),
    t("marketing.standardFeature3"),
    t("marketing.standardFeature4"),
  ];

  const enterprisePlanFeatures = [
    t("marketing.enterpriseFeature1"),
    t("marketing.enterpriseFeature2"),
    t("marketing.enterpriseFeature3"),
  ];
  return (
    <>
      <Navbar />
      <PricingSubpageSection1
        mainTitle={t("marketing.mainTitle")}
        subtitleText={t("marketing.subtitleText")}
        basicPlanTitle={t("marketing.basicPlanTitle")}
        basicPlanDescription={t("marketing.basicPlanDescription")}
        basicPlanFeatures={basicPlanFeatures}
        standardPlanTitle={t("marketing.standardPlanTitle")}
        standardPlanDescription={t("marketing.standardPlanDescription")}
        standardPlanFeatures={standardPlanFeatures}
        enterprisePlanTitle={t("marketing.enterprisePlanTitle")}
        enterprisePlanDescription={t("marketing.enterprisePlanDescription")}
        enterprisePlanFeatures={enterprisePlanFeatures}
      />
      <CoreVirtuesValues />
      <Footer />
    </>
  );
};

export default Marketing;
